/* app/js/src/components/clipping-studio/timeline/clipping-studio-timeline.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  flex: 0 0 auto;
  min-height: 240px;
  background: #edeeef;
  width: 100%;
  display: flex;
  -webkit-user-select: none;
  user-select: none;
  padding-right: 13px;
}
:host > div {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}
.left-col.disabled,
.right-col.disabled {
  pointer-events: none;
  opacity: 0.85;
}
.left-col {
  flex: 0 0 18%;
}
.left-col .stats {
  height: 52px;
  max-height: 52px;
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  margin-bottom: 2px;
  align-self: stretch;
}
.left-col .stats .time {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.left-col .stats .time > div {
  display: flex;
  width: 100px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  height: 16px;
}
.left-col .stats .time > div label {
  flex: 0 0 30%;
}
.left-col .stats .time > div span {
  flex: 0 0 70%;
  font-weight: 600;
}
.left-col .tracks-labels {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  min-height: 0;
}
.left-col .tracks-labels > div {
  width: 100%;
  padding: 0px 0px 0px 12px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  position: relative;
  align-self: stretch;
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 0;
}
.left-col .tracks-labels .track-label-row.track-label-large {
  flex: 2;
}
.left-col .tracks-labels .track-label-row {
  gap: 6px;
}
.left-col .tracks-labels .track-label-row .audio-track-controls {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 1;
  min-width: 0;
  margin-left: auto;
  margin-right: 4px;
}
.left-col .tracks-labels .track-label-row .audio-track-select {
  position: relative;
  flex-shrink: 1;
  min-width: 0;
  max-width: 88px;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-trigger {
  display: flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
  height: 22px;
  padding: 0 4px;
  border: none;
  border-radius: 0;
  background: transparent;
  color: rgb(35, 47, 58);
  cursor: pointer;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 11px;
  line-height: 14px;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-trigger:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
  color: rgb(45, 187, 252);
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-trigger:disabled {
  cursor: default;
  opacity: 0.7;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-chevron {
  flex-shrink: 0;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-bottom: 4px solid currentColor;
}
.left-col .tracks-labels .track-label-row .audio-track-select.open .audio-track-select-chevron {
  border-bottom: none;
  border-top: 4px solid currentColor;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-menu {
  position: absolute;
  left: 0;
  bottom: calc(100% + 2px);
  z-index: 20;
  min-width: 100%;
  max-width: 160px;
  max-height: 160px;
  overflow-y: auto;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #d0d3d6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-menu li {
  padding: 4px 8px;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 11px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-menu li:hover {
  background: rgba(0, 0, 0, 0.04);
}
.left-col .tracks-labels .track-label-row .audio-track-select .audio-track-select-menu li.selected {
  color: rgb(45, 187, 252);
  font-weight: 600;
}
.left-col .tracks-labels .track-label-row .audio-mute-btn {
  width: 24px;
  height: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  background: transparent;
  color: rgb(35, 47, 58);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.left-col .tracks-labels .track-label-row .audio-mute-btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: rgb(45, 187, 252);
}
.left-col .tracks-labels .track-label-row .audio-mute-btn.muted {
  color: rgba(0, 0, 0, 0.54);
}
.left-col .tracks-labels .disabled {
  opacity: 0.35;
}
.left-col .tracks-labels .track-label-faded {
  opacity: 0.35;
}
.right-col {
  flex: 0 0 82%;
  width: 1px;
  min-width: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.right-col .timeline {
  z-index: 2;
  margin-bottom: 2px;
  display: flex;
  min-width: 1px;
  height: 52px;
  max-height: 52px;
  font-size: 9px;
  overflow: hidden;
}
.right-col .timeline .timers {
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: -webkit-fill-available;
  font-size: 0.7rem;
  color: rgb(239, 93, 93);
  font-weight: 600;
}
.right-col .timeline .tooltip {
  position: fixed;
  pointer-events: none;
  transform: translate(-50%, calc(-100% - 8px));
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
}
.right-col .timeline .tooltip .tooltip-thumb {
  width: 160px;
  height: 67px;
  flex-shrink: 0;
  border-radius: 8px 8px 0 0;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(35, 47, 58, 0.5);
}
.right-col .timeline .tooltip .tooltip-label {
  padding: 6px 10px;
  background:
    linear-gradient(
      180deg,
      #5a5a5a 0%,
      #4a4a4a 100%);
  color: #f5f5f5;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.right-col .timeline .tooltip .tooltip-label .tooltip-label-name {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}
.right-col .timeline .tooltip:not(.tooltip-with-thumb) .tooltip-label {
  border-radius: 8px;
}
.right-col .timeline .tooltip.tooltip-with-thumb .tooltip-label {
  border-radius: 0 0 8px 8px;
}
.right-col .timeline .segments {
  position: absolute;
  z-index: 2;
  display: flex;
  width: 100%;
  min-width: 1px;
  height: inherit;
}
.right-col .timeline .segments > * {
  display: flex;
  justify-content: flex-start;
  position: absolute;
}
.right-col .timeline .segments .mam-segment-fills {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}
.right-col .timeline .segments .mam-segment-fills .mam-fill-segment {
  position: absolute;
  top: 0;
  height: 100%;
}
.right-col .timeline .segments .mam-segment-fills .mam-fill-segment.mam-fill-odd {
  background: rgba(45, 187, 252, 0.3);
}
.right-col .timeline .segments .mam-segment-fills .mam-fill-segment.mam-fill-even {
  background: rgba(45, 187, 252, 0.15);
}
.right-col .timeline .segments .pending-region {
  height: 100%;
  background: rgba(45, 187, 252, 0.15);
  pointer-events: none;
}
.right-col .timeline .segments .mark-indicator {
  height: 100%;
  width: 2px;
  pointer-events: none;
}
.right-col .timeline .segments .mark-indicator.mark-in {
  background: rgb(0, 202, 105);
}
.right-col .timeline .segments .mark-indicator.mark-out {
  background: rgb(255, 76, 81);
}
.right-col .timeline .segments .source-boundary-marker {
  top: 0;
  height: 100%;
  width: 2px;
  transform: translateX(-50%);
  background: rgb(45, 187, 252);
  pointer-events: none;
  z-index: 3;
}
.right-col .timeline .segments .clip-segment {
  height: 100%;
  background: rgba(45, 187, 252, 0.3);
  border-left: 1px solid rgb(45, 187, 252);
  border-right: 1px solid rgb(45, 187, 252);
  cursor: pointer;
}
.right-col .timeline .segments .clip-segment.selected {
  background: rgba(45, 187, 252, 0.5);
}
.right-col .timeline .playhead {
  display: none;
  position: absolute;
  z-index: 100;
  height: 100%;
  flex-direction: column;
}
.right-col .timeline .playhead svg {
  fill: rgb(45, 187, 252);
}
.right-col .timeline .playhead svg.playhead-line {
  position: relative;
  left: 5px;
  bottom: 1px;
}
.right-col .timeline .scroll-zone {
  overflow: hidden;
  display: flex;
  position: relative;
  background: #e1e2e3;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.right-col .timeline .scroll-zone::-webkit-scrollbar {
  display: none;
}
.right-col .timeline .scroll-zone.scroll-zone--native {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.right-col .timeline .scroll-zone.scroll-zone--native .time-block {
  display: inline-block;
  position: relative;
}
.right-col .timeline .scroll-zone.scroll-zone--native .time-block .time-label-container {
  position: absolute;
  top: 18px;
  left: -23px;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.right-col .timeline .scroll-zone.scroll-zone--native .time-block .time-label {
  color: #737e8c;
  font-family: "OpenSans-Bold", sans-serif;
  line-height: 13px;
  font-size: 8px;
}
.right-col .timeline .scroll-zone.scroll-zone--native .time-block .block-svg {
  overflow: visible;
}
.right-col .timeline .scroll-zone.scroll-zone--native .time-block .block-svg line {
  stroke: #737e8c;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper {
  position: relative;
  text-align: unset;
  display: flex;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block {
  display: inline-block;
  position: relative;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .time-label-container {
  position: absolute;
  top: 18px;
  left: -23px;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .time-label {
  color: #737e8c;
  font-family: "OpenSans-Bold", sans-serif;
  line-height: 13px;
  font-size: 8px;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .block-svg {
  overflow: visible;
}
.right-col .timeline .scroll-zone ::ng-deep .cdk-virtual-scroll-content-wrapper .time-block .block-svg line {
  stroke: #737e8c;
}
.right-col .tracks {
  z-index: 1;
  flex: 1;
  min-height: 0;
  background: #edeeef;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 1px;
}
.right-col .tracks > div {
  background: #e1e2e3;
  display: flex;
  flex-direction: column;
  line-height: 20px;
  flex: 1;
  align-self: stretch;
  width: 100%;
  min-height: 0;
  justify-content: space-between;
  position: relative;
}
.right-col .tracks > div.track-large {
  flex: 2;
}
.right-col .tracks > div.disabled {
  opacity: 0.35;
}
.right-col .tracks > div > * {
  position: absolute;
  z-index: 2;
  height: 100%;
  width: fit-content;
}
.right-col .tracks > div > *.current-segment-shade {
  z-index: 1;
}
.right-col .tracks > div > .edit-clips-row {
  width: 100%;
}
.right-col .tracks > div .clip-bar {
  background: rgb(45, 187, 252);
  border-radius: 2px;
  cursor: pointer;
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.right-col .tracks > div .clip-bar.selected {
  opacity: 1;
  box-shadow: 0 0 0 1px rgb(41, 170, 229);
}
.right-col .tracks > div .clip-bar .subtitle-segment-label {
  color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
}
.right-col .tracks > div .clip-bar .segment-thumbnails {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 1px;
  gap: 2px;
}
.right-col .tracks > div .clip-bar .segment-thumbnail {
  max-width: 50%;
  max-height: 100%;
  object-fit: contain;
  flex-shrink: 1;
}
.right-col .tracks > div .clip-bar .segment-thumbnail--first {
  margin-right: auto;
}
.right-col .tracks > div .clip-bar .segment-thumbnail--last {
  margin-left: auto;
}
.right-col .tracks > div .edit-clips-row {
  display: flex;
  width: 100%;
  left: 0;
  height: 100%;
  position: absolute;
  min-width: 0;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar {
  flex-basis: 0;
  min-width: 0;
  background: rgb(45, 187, 252);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  opacity: 0.7;
  margin-right: 1px;
  position: relative;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar.cdk-drag-dragging {
  cursor: grabbing;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar.selected {
  opacity: 1;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar .segment-thumbnails {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 1px;
  gap: 2px;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar .segment-thumbnail {
  max-width: 50%;
  max-height: 100%;
  object-fit: contain;
  flex-shrink: 1;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar .segment-thumbnail--first {
  margin-right: auto;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar .segment-thumbnail--last {
  margin-left: auto;
}
.right-col .tracks > div .edit-clips-row .edit-clip-bar .clip-label {
  color: rgb(255, 255, 255);
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
  min-width: 0;
  flex-shrink: 1;
}
.right-col .tracks > div .marker-pin {
  background: rgb(255, 180, 0);
  border-radius: 1px;
  cursor: pointer;
  transform: translateX(-50%);
  width: 4px;
}
.right-col .tracks > div .marker-pin.selected {
  background: rgb(163, 115, 0);
  box-shadow: 0 0 0 1px rgb(224, 158, 0);
}
/*# sourceMappingURL=clipping-studio-timeline.component.css.map */
